import React from 'react';

import IncentiveScrapping from './IncentiveScrapping';

const IncentiveScrappingRoot = () => {
  return <IncentiveScrapping />;
};

export default IncentiveScrappingRoot;
